import { render } from "./AuditLogView.vue?vue&type=template&id=ee32395a"
import script from "./AuditLogView.vue?vue&type=script&lang=js"
export * from "./AuditLogView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__